import { render } from "./DialogA.vue?vue&type=template&id=1051c018&scoped=true"
import script from "./DialogA.vue?vue&type=script&lang=js"
export * from "./DialogA.vue?vue&type=script&lang=js"

import "./DialogA.vue?vue&type=style&index=0&id=1051c018&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1051c018"]])

export default __exports__